// CONSTANTS are all caps.
const NS = "ProvenceMap";
const CLS = "provenceMap";
const WG = `.${CLS}-`;

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/provenceMap.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

import {loadFarmItem} from '../loadWg/farmItem';

export class ProvenceMap {

	constructor($el) {
		// $el is the widget node return by the loadProvenceMap function
		this.$el = $el;
	}

	init() {
		this.loadFarmItem();
	}

	loadFarmItem() {
		// Load FarmItem widget
		loadFarmItem(this.$el, true).then((wgAll) => {
			(wgAll && wgAll.length > 0) ? wgAll.forEach(wg => {
				wg.init();
			}) : '';
		});
	}
}
